import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/townlitOfficial/foundation/FoundationDetail.tsx");
